import React from 'react';

import { di } from 'react-magnetic-di';

import { Box } from '@atlaskit/primitives/compiled';
import ReactRenderer from '@atlaskit/renderer/renderer';

import { asFormAdfField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

export const ViewParagraphRichTextInput = ({
	fieldId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formAdfField = asFormAdfField(formField);

	if (formAdfField === undefined) {
		return <></>;
	}

	return (
		<Box testId={`field-input-paragraph-rich-text-view-${fieldId}`}>
			{formAdfField.value?.adf && <ReactRenderer document={formAdfField.value?.adf} />}
		</Box>
	);
};
